import { formatTransactionRequest } from '../../utils/formatters/transactionRequest.js';
export async function sendUnsignedTransaction(client, request) {
    const request_ = formatTransactionRequest(request);
    const hash = await client.request({
        method: 'eth_sendUnsignedTransaction',
        params: [request_],
    });
    return hash;
}
//# sourceMappingURL=sendUnsignedTransaction.js.map